import {
  Stack,
  Heading,
  Badge,
  Flex,
  Box,
  Text,
  Tooltip,
} from '@chakra-ui/react'
import { LinkIcon } from '@chakra-ui/icons'
import ReactJson from 'react-json-view'
import _keys from 'lodash/keys'
import { Link } from 'react-router-dom'
import { routes } from 'src/lib/routes'
import { useState } from 'react'
import moment from 'moment'
import CellLoading from '../CellLoading/CellLoading'
import { gql } from '@apollo/client'

export const QUERY = gql`
  query superAdminLogsQuery($page: Int, $schoolId: Int) {
    logPage(page: $page, schoolId: $schoolId) {
      logs {
        id
        actorEmail
        actorName
        data
        createdAt
      }
      count
      last
    }
  }
`

export const beforeQuery = ({ page, schoolId }) => {
  page = parseInt(page, 10)
  return { variables: { page, schoolId }, fetchPolicy: 'cache-and-network' }
}

export const Loading = CellLoading

export const Empty = () => (
  <Flex justifyContent="center" textAlign="center" width="100%">
    <Heading marginY={5}>No Log!</Heading>
  </Flex>
)

export const Failure = ({ error }) => <div>Error: {error.message}</div>

export const Success = ({ logPage, page, schoolId }) => {
  page = parseInt(page)
  return (
    <Stack width="100%" overflowY="auto" height="calc(100vh - 5.4rem)">
      {schoolId ? null : (
        <Heading size="lg" fontWeight={300} margin={5}>
          Super Admin Log
        </Heading>
      )}
      <Box width="100%" padding={2}>
        <table
          className="pure-table pure-table-horizontal"
          style={{ width: '100%' }}
        >
          <thead>
            <tr>
              <th width="210px">Whodunit</th>
              <th width="120px">School</th>
              <th width="90px">Operation</th>
              <th>Changes</th>
            </tr>
          </thead>
          <tbody>
            {logPage.logs.map((log, idx) => (
              <LogLine
                key={log.id}
                log={log}
                cls={idx % 2 === 1 ? 'pure-table-odd' : ''}
                schoolScoped={Boolean(schoolId)}
              />
            ))}
          </tbody>
        </table>
      </Box>
      <Box textAlign="center" color="blue">
        {page > 1 ? (
          <Link to={routes.log({ page: page - 1 })}>‹ Prev</Link>
        ) : null}
        {page > 1 && !logPage.last ? ' | ' : null}
        {logPage.last ? null : (
          <Link to={routes.log({ page: page + 1 })}>Next ›</Link>
        )}
      </Box>
    </Stack>
  )
}

const LogLine = ({ log, cls, schoolScoped }) => {
  const [open, setOpen] = useState()
  const data = JSON.parse(log.data)
  const fields = _keys(data.diff)
  return (
    <tr
      className={cls}
      onClick={() => setOpen(!open)}
      style={{ cursor: 'pointer' }}
    >
      <td>
        <Tooltip label={log.actorEmail} placement="top">
          <Text fontSize="sm">{log.actorName}</Text>
        </Tooltip>
        <Text fontSize="xs" color="#999">
          {moment(log.createdAt).calendar({ sameElse: 'YYYY-MM-DD h:mm A' })}
        </Text>
      </td>
      <td>
        {schoolScoped ? (
          <><Badge>{data.type}-{data.id}</Badge><LinkIcon /></>
        ) : (
          <Link
            to={
              data.type === 'school'
                ? `${routes.school({ id: data.id })}?tab=1`
                : routes[data.type] && routes[data.type]({ id: data.id })
            }
          >
            <Badge>{data.type}-{data.id}</Badge> <LinkIcon />
          </Link>
        )}
      </td>
      <td>{data.op}</td>
      <td>
        {open ? (
          <>
            <ReactJson
              src={data.prev}
              displayDataTypes={false}
              enableClipboard={false}
              name="original"
            />
            <br />
            <ReactJson
              src={data.diff}
              displayDataTypes={false}
              enableClipboard={false}
              name="changes"
            />
            <br />
            <ReactJson
              src={data.input}
              displayDataTypes={false}
              enableClipboard={false}
              name="input"
            />
          </>
        ) : (
          fields.map((f, i) => (
            <span key={i}>
              <Badge>{f}</Badge>
              <br />
            </span>
          ))
        )}
      </td>
    </tr>
  )
}
